"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineWithFeatureId = void 0;
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const segment_1 = require("../../cadplugins/cad/segment");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
class LineWithFeatureId extends segment_1.RLine {
    constructor(start_point, end_point, featureId) {
        super(start_point, end_point);
        this._featureId = featureId;
    }
    getFeatureId() {
        return this._featureId;
    }
    getClosestPoint(point) {
        //借助jsts库的Linesegment类计算最近的点
        let segment = new LineSegment_js_1.default(this.getStartPoint().x, this.getStartPoint().y, this.getEndPoint().x, this.getEndPoint().y);
        let closestPoint = segment.closestPoint(new Coordinate_js_1.default(point.x, point.y));
        return new ltpoint_1.LTPoint(closestPoint.x, closestPoint.y);
    }
}
exports.LineWithFeatureId = LineWithFeatureId;
